// Lib
import { totalImpressionsConfig } from '@/lib/analytics/kpis/pinterest/totalImpressions';
import { SIZE_50 } from '@/lib/gridElements/size';

// Components
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';
import { KPIDefault } from '@/components/base/Kpi/KpiDefault';

// Types
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';

export const mediaViewerImpressionsConfig: KpiType<typeof MediaViewerKpiLoader, typeof KPIDefault> =
    {
        ...totalImpressionsConfig,
        id: 'impressions',
        size: SIZE_50,
        tooltip: null,
        loader: MediaViewerKpiLoader
    };
